import React, { useEffect, useState } from "react";
import { Checkbox, Spin } from "antd";
import { getImg } from "../../Api/getImg";
import { useResponsive } from "./Modals/EditColumnModal";


const ServicesStep = ({ 
  doctorServices, 
  selectedServices, 
  setSelectedServices, 
  servicesLoading 
}) => {
  const { isMobile } = useResponsive();

  return (
    <div className={`space-y-${isMobile ? '3' : '4'} p-0`}>
      <div className={`text-center ${isMobile ? 'mb-4' : 'mb-6'}`}>
        <h3 className={`font-bold text-gray-800 mb-2 ${isMobile ? 'text-lg' : 'text-2xl'}`}>
          Select Services
        </h3>
        <p className={`text-gray-600 ${isMobile ? 'text-sm' : ''}`}>
          {isMobile ? "Services provided to patient" : "Choose the services provided to the patient"}
        </p>
      </div>

      <Spin spinning={servicesLoading}>
        <div className={`${isMobile ? 'max-h-80' : 'max-h-96'} overflow-y-auto border rounded-xl ${isMobile ? 'p-2' : 'p-3'} bg-gray-50`}>
          {doctorServices.length > 0 ? (
            <div className={`space-y-${isMobile ? '2' : '4'}`}>
              {doctorServices.map((service) => (
                <div 
                  key={service.id} 
                  className={`bg-white rounded-lg ${isMobile ? 'p-2' : 'md:p-4'} shadow-sm hover:shadow-md transition-shadow duration-300`}
                >
                  <Checkbox
                    checked={selectedServices.includes(service.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedServices(prev => [...prev, service.id]);
                      } else {
                        setSelectedServices(prev => prev.filter(id => id !== service.id));
                      }
                    }}
                    className="w-full"
                  >
                    <div className={`flex items-center ${isMobile ? 'gap-2' : 'gap-3'}`}>
                      <img
                        src={getImg(service.photoID)}
                        className={`${isMobile ? 'w-10 h-10' : 'w-12 h-12'} rounded-lg object-cover shadow-sm`}
                        alt={service.title}
                      />
                      <div className="min-w-0 flex-1">
                        <div className={`font-medium text-gray-800 ${isMobile ? 'text-sm' : ''}`}>
                          {service.title}
                        </div>
                        {service.price >= 0 && (
                          <div className={`font-bold text-green-600 ${isMobile ? 'text-xs' : 'text-sm'}`}>
                            💰 ${service.price}
                          </div>
                        )}
                      </div>
                    </div>
                  </Checkbox>
                </div>
              ))}
            </div>
          ) : (
            <div className={`text-center text-gray-500 ${isMobile ? 'py-6' : 'py-8'}`}>
              <div className={`${isMobile ? 'text-3xl' : 'text-4xl'} mb-2`}>🔍</div>
              <div className={isMobile ? 'text-sm' : ''}>No services available</div>
            </div>
          )}
        </div>
      </Spin>

      {selectedServices.length > 0 && (
        <div className={`mt-4 ${isMobile ? 'p-3' : 'md:p-4'} bg-blue-50 rounded-xl border border-blue-200`}>
          <div className={`font-medium text-blue-800 ${isMobile ? 'text-xs' : 'text-sm'}`}>
            ✅ Selected Services: {selectedServices.length}
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicesStep;